import {
  ManagerNotificationEventData,
  ManagerNotificationType
} from './server';

export type SlaToastNotificationType =
  | ManagerNotificationType.slaWarning
  | ManagerNotificationType.slaViolation;

export const isSlaToastNotificationType = (
  type: ManagerNotificationType
): type is SlaToastNotificationType =>
  type === ManagerNotificationType.slaWarning ||
  type === ManagerNotificationType.slaViolation;

export const isSlaToastEvent = (
  data: ManagerNotificationEventData
): data is ManagerNotificationEventData & {
  type: SlaToastNotificationType;
} => isSlaToastNotificationType(data.type);
